import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const cardsFilterSchema = z.object({
	search: optionalFilterString,
	statuses: optionalFilterString,
});

export type CardsFilter = z.infer<typeof cardsFilterSchema>;
